import {Component, Input} from '@angular/core';
import { FinanceService } from '../../../../services/api/finance.service';
import { HelpersService } from '../../../../services/helpers.service';
import { CompanyContractModel, ContractStepModel} from '../../../../models/contract.model';
import { MatDialogRef } from '@angular/material/dialog';
import { DatePipe, TitleCasePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { ContractDataService } from '../../services/contract-data.service';
import { ICreditLetter, TPaymentData } from '../../../../models/finance.model';
@Component({
    selector: 'app-contract-step-credit-letter-view',
    templateUrl: './contract-step-credit-letter-view.component.html',
    styleUrl: './contract-step-credit-letter-view.component.scss'
})
export class AppContractStepCLViewComponent {
  @Input() clStep: ContractStepModel|null=null;
  @Input() clInfo: TPaymentData|null=null;
  @Input() contractParties:CompanyContractModel[] = []

  paymentTotal:number|string|undefined = ''
  paymentDetails:{key:string,value:string}[]=[]
  paymentError:boolean = false;
  constructor(
      public dialogRef:MatDialogRef<AppContractStepCLViewComponent>,
      public financeService: FinanceService,
      public helpersService: HelpersService,
      public contractDataService: ContractDataService,
      private datePipe: DatePipe,
      private titleCasePipe: TitleCasePipe,
      private translateService:TranslateService
  ) {}

  ngOnInit(): void {
    let creditLetter = this.contractDataService.getCachedStepTargetData(this.clStep) as ICreditLetter 
    this.paymentTotal = creditLetter.total;
      let fullParties = this.contractParties.map(el=>{
      return {
        name:el.project.name,
        guid:el.project.guid,
        subtype:el.project.subtype==='MEMBER'? 'MEMBER' : 'PROJECT' }
    }) 
      let payerName = fullParties.find(el=>el.guid === (creditLetter?.payment?.payer_guid||creditLetter.owner_guid))?.name
      let tempStatus = this.translateService.instant('FINANCE.PAYMENT.PAY_STATUS.' + this.statusConstructor(creditLetter.payment?.payment_status||'')) + ' (' + creditLetter.payment?.payment_status + ')' 
      this.paymentDetails = [
          {key:'payer',value:this.titleCasePipe.transform(payerName)||''}, 
          {key:'status',value:tempStatus},
          {key:'created_at',value: this.datePipe.transform(creditLetter?.payment?.created_at,'dd.MM.yyyy')||''}, 
          {key:'guid',value:this.clStep?.target_key||''},
          {key:'updated_at',value:this.datePipe.transform(creditLetter?.payment?.updated_at,'dd.MM.yyyy')||''} 
      ]
  }
  cancelAction() {
    this.dialogRef.close()
  }
  statusConstructor(payment_status: string): string {
    switch (payment_status) {
        case 'NEW': return 'INITIATED';
        case 'PROMISED':return 'WORK';
        case 'APPROVED':return'APPROVED';
        case 'EXECUTION':return 'WORK';
        case 'SUCCESS': return 'SUCCESS';
        default: return 'INITIATED';
    }
  }
}
